import { lazy } from 'react';

export const DashboardPage = lazy(() => import('./DashboardPage'));
